export const EnvironmentDev = {
    name: 'dev',
    apiUrl: 'http://127.0.0.1:8000/api',
    clientUrl: 'http://127.0.0.1:3000',
};

export const EnvironmentProd = {
    name: 'prod',
    production: true,
    apiUrl: 'https://atila-7.herokuapp.com/api',
    clientUrl: 'https://atila.ca',
};

// set to EnvironmentDev as the default so we can use type hinting and the autocomplete feature
let Environment = EnvironmentDev;

// Only access window in browser environment
if (typeof window !== 'undefined') {
    if (window.location.host.includes('localhost')) {
        Environment = EnvironmentDev;
    } else if (window.location.host.includes('atila.ca')) {
        Environment = EnvironmentProd;
    }
}

export default Environment;